import styled from "@emotion/styled";
import * as React from "react";
import { FieldRenderProps } from "react-final-form";

import { IInputFieldProps, InputField } from "@livechat/design-system";
import { DesignToken, RadiusToken } from "@livechat/design-system-react-components";

import { shouldDisplayError } from "helpers/final-form";

export interface IProps {
  name: string;
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onBlur?: (event?: React.FocusEvent<HTMLTextAreaElement>) => void;
  onFocus?: (event?: React.FocusEvent<HTMLTextAreaElement>) => void;
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  defaultValue?: any;
  forceError?: boolean;
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line react/display-name
export const InputFieldFinalForm = React.forwardRef<
  HTMLInputElement,
  React.PropsWithRef<FieldRenderProps<string, HTMLInputElement> & IInputFieldProps>
>(({ input, meta, forceError, ...otherProps }, ref) => {
  let shouldShowError: boolean;
  if (forceError) shouldShowError = true;
  else shouldShowError = shouldDisplayError(meta);

  return <InputField ref={ref} {...input} error={shouldShowError ? meta.error : undefined} {...otherProps} />;
});

// works fine as long as you don't need to pass a ref
export const InputFieldFullWidthFinalForm = styled(InputFieldFinalForm)`
  input {
    width: 100%;
    border: none;
    background-color: transparent;
    color: var(${DesignToken.ContentBasicPrimary});
    border-radius: var(${RadiusToken.Radius3});
    min-height: 36px;
    height: 36px;
    font-size: 14px;
    transition: all 0.2s ease-in-out;

    ::placeholder {
      color: var(${DesignToken.ContentBasicPlaceholder});
    }

    &:focus {
      box-shadow: 0 0 0 1px var(${DesignToken.ActionPrimaryDefault});
    }
  }
`;

// this solution is needed because of problems with the way emotion typings and passing refs work
export const InputFieldFullWidthWrapper = styled.div`
  input {
    width: 100%;
  }
`;
